import React, { useContext, useState, useEffect } from "react";
import { useQuery } from "react-apollo";
import { useHistory } from "react-router-dom";
import {
  ALL_SYSTEM_CODES_QUERY,
  SYSTEM_CODE_PAGINATION_QUERY
} from "../../../graphql/SystemCodes/SystemCodes.graphql";
import {
  AddSystemCodeForm,
  EditSystemCodeForm
} from "../../../components/SystemCodes";
import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";

import { COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import SystemCodeFilters from "./SystemCodeFilters";
import {
  getFilterState,
  saveFilterState,
  ourToast as toast
} from "../../../utils";
import { CURRENT_USER_QUERY } from "../../../graphql/Users/Users.graphql";
import Loading from "../../../components/Loading";

const SystemCodesPage = () => {
  const history = useHistory();
  const { data, loading, error } = useQuery(CURRENT_USER_QUERY);
  const [Auth, setAuth] = useState(false);

  const INITIAL_FILTER_STATE = getFilterState("SYSTEM_CODE_FLEET_FILTERS", {
    Active: true,
    Type: "User",
    OR: [
      {
        Category: "Fleet"
      },
      {
        CodeName: "InspectionCd"
      }
    ]
  });

  const [filters, setFilters] = useState({ ...INITIAL_FILTER_STATE });
  const { setModalOpen } = useContext(ModalContext);

  useEffect(() => {
    if (data && !loading && !error && !Auth) {
      if (
        data.Me.UserGroupMemberships.some(ship =>
          ["ADMIN", "FLEET", "MGMNT"].includes(ship.UserGroup.GroupId)
        )
      ) {
        setAuth(true);
      } else {
        toast.error("Access denied");
        history.push("/");
      }
    }
  }, [Auth, data, error, history, loading]);

  const handleSetFilters = inputs => {
    saveFilterState("SYSTEM_CODE_FLEET_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () =>
    handleSetFilters({
      Active: true,
      Type: "User",
      OR: [
        {
          Category: "Fleet"
        },
        {
          CodeName: "InspectionCd"
        }
      ]
    });

  if (loading) return <Loading />;
  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={SystemCodeFilters}
        columns={COLUMNS}
        filters={filters}
        name="SystemCodes"
        query={ALL_SYSTEM_CODES_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="System Codes"
        onAddClick={() => {
          setModalOpen(
            true,
            <AddSystemCodeForm
              setModalOpen={() => setModalOpen(false, "")}
              where={{
                Type: "User",
                // Category: "Fleet",
                Category_in: ["Fleet", "Inventory"]
              }}
            />
          );
        }}
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_SYSTEM_CODES_QUERY}
        initialSortBy={[
          { id: "Category", desc: false },
          { id: "CodeName", desc: false },
          { id: "ListOrder", desc: false }
        ]}
        name="SystemCode"
        paginationQuery={SYSTEM_CODE_PAGINATION_QUERY}
        where={filters}
        onRowClick={code =>
          setModalOpen(
            true,
            <EditSystemCodeForm
              code={code}
              setModalOpen={() => setModalOpen(false, "")}
              where={{ Type: "User", Category: "Fleet" }}
            />
          )
        }
      />
    </React.Fragment>
  );
};

SystemCodesPage.propTypes = {};

export default SystemCodesPage;
